import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class SupplierSettingsApi {
  static getSettings = (organizationId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/supplier-settings`,
    );
  };

  static updateSettings = (organizationId, data) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/supplier-settings`,
      data,
    );
  };
}
